// extracted by mini-css-extract-plugin
export default {"orderTestItem":"OrderTestItem_orderTestItem__66h73","orderTestItem__arrow":"OrderTestItem_orderTestItem__arrow__8dsk8"};